import store from 'app/store';

import { selectAuthToken } from 'features/auth/authSelectors';

import { isHttpUrl } from 'utils/urlUtils';

import api from './api';
import isS3SignedUrl from './isS3SignedUrl';

const fetchWithAuth = async (
  url: string,
  forceExternal?: boolean
): Promise<Response> => {
  const isAbsoluteUrl = isHttpUrl(url);
  const isS3Url = isS3SignedUrl(url);

  if (forceExternal || isAbsoluteUrl) {
    const headers: HeadersInit = {};

    if (!isS3Url) {
      const token = selectAuthToken(store.getState());
      if (token) {
        headers.Authorization = token;
      }
    }

    return fetch(url, { headers });
  }

  const blob = await api.getFile(url);
  return new Response(blob);
};

export default fetchWithAuth;
